import React from 'react';
import { ToggleProps } from '../../../types/DesignSystem/Toggle';
import Typography from '../Typography/Typography';

const Toggle: React.FC<ToggleProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
}) => {
  return (
    <div className={`tw-flex tw-items-center tw-gap-3 ${className}`}>
      <button
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`tw-relative tw-w-11 tw-h-6 tw-rounded-full tw-transition-colors tw-flex-shrink-0 ${
          disabled
            ? checked
              ? 'tw-bg-green-success-100 tw-shadow-sm tw-cursor-not-allowed'
              : 'tw-bg-grey-100 tw-shadow-sm tw-cursor-not-allowed'
            : checked
            ? 'tw-bg-green-success-500 tw-shadow-md hover:tw-opacity-90 tw-cursor-pointer'
            : 'tw-bg-grey-500 tw-shadow-md hover:tw-opacity-90 tw-cursor-pointer'
        }`}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        aria-label={label}
      >
        <div
          className={`tw-absolute tw-top-1 tw-w-4 tw-h-4 tw-bg-white tw-rounded-full tw-transition-transform ${
            checked ? 'tw-translate-x-6' : 'tw-translate-x-1'
          }`}
          style={{
            boxShadow: disabled ? '0px 4px 4px rgba(0,0,0,0.05)' : '0px 4px 4px rgba(0,0,0,0.25)',
          }}
        />
      </button>
      <Typography variant="body-primary" className="tw-text-grey-900">
        {label}
      </Typography>
    </div>
  );
};

export default Toggle;
